module.exports = __webpack_public_path__ + "static/logo-brand.1a52a773.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-brand.svg
// module id = 249
// module chunks = 168707334958949